import { io } from "socket.io-client";

// Hardcoded chat service URL
const CHAT_URL = "https://apnamestri-chatsystem.onrender.com";

const getAuthToken = () => {
  const stored = localStorage.getItem("authToken");
  if (stored) return stored;

  const cookies = document.cookie.split(";");
  for (let c of cookies) {
    const [name, value] = c.trim().split("=");
    if (name === "authToken") return value;
  }
  return null;
};

export const socket = io(CHAT_URL, {
  autoConnect: false,
  withCredentials: true,
  transports: ["websocket", "polling"],
  auth: { token: getAuthToken() },
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
});

socket.on("connect", () =>
  console.log("[Chat] Socket connected:", socket.id)
);
socket.on("connect_error", (err) =>
  console.warn("[Chat] Socket error:", err.message)
);
socket.on("disconnect", (reason) =>
  console.log("[Chat] Disconnected:", reason)
);

export const connectChatSocket = (token) => {
  socket.auth = { token: token || getAuthToken() };
  if (!socket.connected) socket.connect();
};

export const disconnectChatSocket = () => {
  if (socket.connected) socket.disconnect();
};
